import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { SimpleBlockContent } from "@components/SimpleBlockContent";
import { useRating } from "@components/ProductCard/hooks/useRating";
import { useMobileDetect } from "@hooks/index";
import { StyledWith } from "../StyledWith";
import { Button } from "@components/Button";
import styles from "./styles/summary.module.css";
import { LogoAfterpay } from "@icons/logo-afterpay";
import { useCurrencyState } from "@hooks/useCurrency";
import * as currencyService from "@services/format/currency";
import { Rating } from "./Rating";

export function Summary({
  price,
  amount,
  compareAtPrice,
  finalSale,
  description,
  openReviewsDrawer,
  scrollToReviews,
}) {
  const { currency } = useCurrencyState();
  const { state } = useStateMachine();
  const currentDevice = useMobileDetect();
  const { locale } = useRouter();
  const { t } = useTranslation("productpage");
  const isMobile = currentDevice.isMobile();
  const rating = useRating(state["product"].productReferenceV2, state[`productGroup`]);
  const bundleLinks = state[`productGroup`].bundleLinks;
  const styledWith = state["product"].styledWith;

  const isFrench = locale === "fr";

  const AFTERPAY = t("sezzle");
  const WITH = t("with");
  const ALL_REVIEWS = t("all-reviews-button");

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.header}>
          <h2 className={styles.title}>
            {/* {state["productGroup"].title.replace(/(Wo)?[Mm]en['’]?s /g, "")} */}
            {state["productGroup"].title}
          </h2>
        </div>
        <div className={styles.priceReviews}>
          <div className={styles.price}>
            <span>{price}</span>
            {compareAtPrice && (
              <span className={styles.priceCompareAt}>{compareAtPrice.replace(/[CA]/g, "")}</span>
            )}

            {finalSale && <span className="product-finalSale">Final Sale</span>}
          </div>
        </div>
        <div className={styles.sezzle}>
          <span>
            {AFTERPAY} {currencyService.formatPrice(amount / 4, currency)} {WITH}
          </span>{" "}
          <LogoAfterpay />
        </div>
        <div>
          {rating && rating.average && (
            <div className={styles.rating} onClick={scrollToReviews}>
              <Rating average={rating?.average} />
              <Button
                variant="tertiary"
                description="allReviews"
                descriptionText="Show reviews drawer"
              >
                ({rating?.count} {t("reviews")})
              </Button>
            </div>
          )}
        </div>
      </div>
      {description}
      {bundleLinks && bundleLinks.length && <SimpleBlockContent blocks={bundleLinks} />}
      {styledWith && !isMobile && !isFrench && (
        <StyledWith customTitle={styledWith.customTitle} products={styledWith.products} />
      )}
    </div>
  );
}

Summary.propTypes = {
  amount: PropTypes.number.isRequired,
  price: PropTypes.string.isRequired,
  compareAtPrice: PropTypes.string,
  finalSale: PropTypes.bool.isRequired,
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  openReviewsDrawer: PropTypes.func.isRequired,
};
